import { Link } from 'react-router-dom'

import { Badge, Card } from '@/components/ui'
import type { Session } from '@/pages/workouts/api'
import { groupSets, PR_LABELS } from '@/pages/workouts/logic'

/** Отдельный итог рекордов, а не только маленькие отметки у подходов ниже. */
export function WorkoutRecords({ session }: { session: Session }) {
  const records = groupSets(session).flatMap((group) => {
    const labels = new Set(group.sets.filter((s) => s.completed && !s.is_warmup).flatMap((s) =>
      Object.entries(s.is_pr ?? {}).filter(([, yes]) => yes).map(([key]) => PR_LABELS[key as keyof typeof PR_LABELS]),
    ))
    return labels.size ? [{ id: group.exercise_id, position: group.position, name: group.name, labels: [...labels] }] : []
  })
  if (!records.length) return null
  return (
    <Card title="Рекорды этой тренировки" className="mt-4">
      <ul className="divide-y divide-border">
        {records.map((record) => <li key={`${record.id}:${record.position}`} className="flex flex-wrap items-center justify-between gap-2 py-2 first:pt-0 last:pb-0">
          <Link to={`/exercises/${record.id}`} className="hit-area text-sm font-medium hover:text-accent">{record.name}</Link>
          <Badge tone="warning">{record.labels.join(', ')}</Badge>
        </li>)}
      </ul>
    </Card>
  )
}
